module.exports = __webpack_public_path__ + "img/tumblr.dd01e0e7.svg";